import { default as GroupNode, GroupNodeProps } from './GroupNode';
import { observer } from 'mobx-react';
import { shallowCompare } from 'office-ui-fabric-react/lib/Utilities';
import Droppable from 'owa-dnd/lib/components/Droppable';
import { getGroupsStore } from 'owa-groups-shared-store';
import GroupInformation from 'owa-groups-shared-store/lib/schema/GroupInformation';
import * as React from 'react';
import { DragData } from 'owa-dnd/lib/utils/dragDataUtil';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import getGroupNodeViewStateFromId from '../selector/getGroupNodeViewStateFromId';
import DropEffect from 'owa-dnd/lib/store/schema/DropEffect';

export interface GroupListNodeProps extends GroupNodeProps {
    onListNodeDrop?: (dragData: DragData, groupId: string) => void;
    canDropOnListNode: (dragData: DragData) => DropEffect;
}

@observer
export default class GroupListNode extends React.Component<GroupListNodeProps, {}> {
    constructor(props: GroupListNodeProps) {
        super(props);
    }

    shouldComponentUpdate(nextProps: GroupNodeProps, nextState: {}) {
        return !shallowCompare(this.props, nextProps);
    }

    render() {
        const viewState = getGroupNodeViewStateFromId(this.props.groupId);

        return (
            <Droppable
                dropViewState={viewState.drop}
                onDrop={this.onDrop}
                canDrop={this.props.canDropOnListNode}>
                <GroupNode
                    selectGroup={this.props.selectGroup}
                    isSelected={this.props.isSelected}
                    renderRightCharm={this.props.renderRightCharm}
                    renderRightCharmHover={this.props.renderRightCharmHover}
                    chevronProps={null}
                    customIcon={null}
                    displayName={this.props.displayName}
                    groupId={this.props.groupId}
                    isDroppedOver={viewState.drop.isDragOver}
                    onContextMenu={this.onContextMenu}
                    renderCustomTreeNodeDisplay={null}
                    customData={this.props.customData}
                    showHoverStateOnDroppedOver={
                        viewState.drop.draggableItemType == DraggableItemTypes.MailListRow ||
                        viewState.drop.draggableItemType ==
                            DraggableItemTypes.MultiMailListMessageRows
                    }
                />
            </Droppable>
        );
    }

    private onContextMenu = (evt: React.MouseEvent<EventTarget>, group: GroupInformation) => {
        const { onContextMenu, groupId } = this.props;

        if (onContextMenu) {
            evt.stopPropagation();
            evt.preventDefault();

            const groupSmtp = groupId.toLowerCase();
            const groups = getGroupsStore().groups;
            if (groups.has(groupSmtp)) {
                const group = groups.get(groupSmtp);
                onContextMenu(evt, group);
            }
        }
    };

    private onDrop = (dragData: DragData) => {
        if (this.props.onListNodeDrop) {
            this.props.onListNodeDrop(dragData, this.props.groupId);
        }
    };
}
